function splitInHalf<T>(array: T[]): T[][] {
  return [
    array.slice(0, array.length / 2),
    array.slice(array.length / 2)
  ]
}

function alphabetical(x: string, y: string) {
  const a = x.toLowerCase()
  const b = y.toLowerCase()

  if (a === b) {
    return 0
  }

  return a > b ? 1 : -1
}

export {
  splitInHalf,
  alphabetical,
}
